export const urls = {
  activeUrl:
    'https://goals-tracker-25f88-default-rtdb.firebaseio.com/activeGoals.json',
  completedUrl:
    'https://goals-tracker-25f88-default-rtdb.firebaseio.com/completedGoals.json',
  failedUrl:
    'https://goals-tracker-25f88-default-rtdb.firebaseio.com/failedGoals.json',
};
